<template>

<div id="footer" class="section section-dark">

  <div class="one-third-block-footer one-third-block-first">

    <Link :text="$t('footer.ethics')" href="/ethics"/>

    <Link :text="$t('footer.about')" href="/#slide05"/>

    <Link :text="$t('footer.privacy')" href="/privacy-policy"/>

  </div>

  <div class="one-third-block-footer one-third-block-middle">

    <SocialBlock size="lg"/>

  </div>

  <div class="one-third-block-footer one-third-block-last">
    © Quantified Reading S.L. 2020
  </div>

</div>

</template>

<script>
import Link from './general/texts/Link.vue'
import SocialBlock from './general/social/SocialBlock.vue'

export default {
  name: 'Footer',
  components: {
    Link,
    SocialBlock
  }
}
</script>

<style lang="scss" scoped>
.section {
  color: #bac6e6;
  padding: 30px 15%;

  .one-third-block-footer {
    width: 30%;
    font-size: 14px;
    vertical-align: baseline !important;
    display: inline-block;
    vertical-align: text-top;
  }

  .one-third-block-first {
    margin-right: 2%;
  }

  .one-third-block-middle {
    text-align: center;
    margin-right: 2%;
    margin-left: 2%;
  }

  .one-third-block-last {
    text-align: right;
    margin-left: 2%;
  }
}

::v-deep svg {
  padding: 0 20px;
}

@media (max-width: 600px), (max-device-width: 600px) {
  .section {
    .one-third-block-footer {
      width: 100%;
      display: block;
    }

    .one-third-block-first {
      margin: 10px 0;
    }

    .one-third-block-middle {
      text-align: left;
      margin: 10px 0;
    }

    .one-third-block-last {
      text-align: left;
      margin: 10px 0;
    }
  }

  ::v-deep svg {
    padding: 0;
    padding-right: 40px !important;
  }
}
</style>
